module.exports = __webpack_public_path__ + "static/media/bg_13.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_13.png
// module id = 58
// module chunks = 0